import {Dispatch, SetStateAction, useEffect, useRef, useState} from "react";
import {HubConnection, HubConnectionBuilder, LogLevel} from "@microsoft/signalr";
import {ApiUrl_SignalR_CommentHub} from "../Endpoints";
import {CommentNotificationDTO} from "./signalr.models";
import {JwtUtils} from "../auth/JwtUtils";
import getToken = JwtUtils.getToken;
import {useAuthenticationContext} from "../auth/AuthenticationContext";
import {
    useFlintNotificationContext
} from "../../components/page_components/common/notifications/FlintNotificationContext";

export default function useCommentSignalRConnection() {
    const connectionIdRef = useRef<string | null>(null);
    const commentHubUrl: string = ApiUrl_SignalR_CommentHub;
    const progressEndpointName: string = "ReceiveNewComment";
    const {comments, rootModel} = useAuthenticationContext();
    let connection: HubConnection | null = null;

    useEffect(() => {
        if (!rootModel?.CurrentUserProfile.ShowNewCommentsPopup)
            return;
        startSignalConnection();
        return () => {
            connection?.stop()
                .then(() => console.log("Comment hub SignalR connection stopped"))
                .catch((err) => console.error("Error stopping comment hub SignalR connection:", err));
        };
    }, [rootModel?.CurrentUserProfile.LabId, rootModel?.CurrentUserProfile.DivisionId])

    function playDingDong() {
        const audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();

        function playTone(frequency: number, startTime: number, duration: number) {
            const oscillator = audioCtx.createOscillator();
            const gain = audioCtx.createGain();

            oscillator.type = 'sine';
            oscillator.frequency.setValueAtTime(frequency, audioCtx.currentTime + startTime);

            gain.gain.setValueAtTime(0.2, audioCtx.currentTime + startTime); // Volume
            gain.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + startTime + duration);

            oscillator.connect(gain).connect(audioCtx.destination);

            oscillator.start(audioCtx.currentTime + startTime);
            oscillator.stop(audioCtx.currentTime + startTime + duration);
        }

        // "Ding" — high pitch
        playTone(1880, 0, 0.25);   // 880 Hz, immediately, lasts 250ms

        // "Dong" — low pitch after slight delay
        playTone(150, 0.25, 0.25);  // 440 Hz, starts after 400ms, lasts 400ms
    }

    function startSignalConnection() {
        connection = new HubConnectionBuilder()
            .withUrl(commentHubUrl, {
                withCredentials: false,
                accessTokenFactory: () => getToken() || "",
                //transport: HttpTransportType.WebSockets,
                //skipNegotiation: true,
            })
            .withAutomaticReconnect()
            //.configureLogging(LogLevel.Warning)
            .configureLogging(LogLevel.Trace)
            .build();

        connection.on(progressEndpointName, (comment: CommentNotificationDTO) => {
            if (comments.append(comment))
                playDingDong();
        });

        connection
            .start()
            .then(() => {
                connectionIdRef.current = connection?.connectionId ?? null;
                console.log("Comment hub SignalR connection started with ID:", connection?.connectionId);
            })
            .catch((err) => console.error("Comment hub SignalR Connection Error:", err));

    }


    return {
        commentData: {
            connectionId: connectionIdRef.current,
            comments: {
                get: comments.get,
                //set: setComments // Allows setting comments manually if needed
            }
        }
    };
}

export interface IProgressReport {
    connectionId: string | null;
    state: {
        comments: { get: CommentNotificationDTO, set: Dispatch<SetStateAction<CommentNotificationDTO>> }
    };
}